var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#3478F5",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    viewBox: "0 0 294.843 294.843",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,40.77c3.313,0,6-2.686,6-6c0-9.256,7.53-16.786,16.786-16.786h53.675l42.243,46.147   c1.137,1.242,2.743,1.949,4.426,1.949h136.928c9.256,0,16.786,7.53,16.786,16.786c0,3.314,2.687,6,6,6s6-2.686,6-6   c0-15.873-12.913-28.786-28.786-28.786H131.771L89.529,7.933c-1.137-1.242-2.743-1.949-4.426-1.949H28.786   C12.913,5.984,0,18.897,0,34.77C0,38.083,2.687,40.77,6,40.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.057,94.104H131.771L89.529,47.957c-1.137-1.242-2.743-1.949-4.426-1.949H28.786C12.913,46.008,0,58.921,0,74.793   v118.628c0,3.313,2.687,6,6,6s6-2.687,6-6V74.793c0-9.256,7.53-16.786,16.786-16.786h53.675l42.243,46.147   c1.137,1.242,2.743,1.949,4.426,1.949h136.928c9.256,0,16.786,7.53,16.786,16.786v137.184c0,9.255-7.53,16.786-16.786,16.786   H28.786c-9.256,0-16.786-7.53-16.786-16.786c0-3.313-2.687-6-6-6s-6,2.687-6,6c0,15.873,12.913,28.786,28.786,28.786h237.271   c15.873,0,28.786-12.913,28.786-28.786V122.89C294.843,107.017,281.93,94.104,266.057,94.104z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9c8026fcfa80a0db0ba65ba93fc128a3.svg";
export { ForwardRef as ReactComponent };